'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-zipper';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e3a5';
var svgPathData = ['M16 256C16 123.5 123.5 16 256 16S496 123.5 496 256c0 16.6-1.7 32.9-4.9 48.6l13.4 13.4c-5 20.2-12.4 39.4-21.9 57.3L433 325.7c-9.4-9.4-24.6-9.4-33.9 0L357.7 367c-9.4 9.4-9.4 24.6 0 33.9l52.7 52.7c1.3 1.3 2.6 2.5 3.9 3.6-15.1 11.9-31.6 22.1-49.1 30.4l-12.1-12.1C323.4 488.7 290.5 496 256 496 123.5 496 16 388.5 16 256zm136 64l0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48c0-4.4-3.6-8-8-8s-8 3.6-8 8zm8-112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm56 112l0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48c0-4.4-3.6-8-8-8s-8 3.6-8 8zm64 0l0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48c0-4.4-3.6-8-8-8s-8 3.6-8 8zm40-112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z', 'M256 496c34.5 0 67.4-7.3 97.1-20.4l12.1 12.1C332 503.3 295 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256c0 21.4-2.6 42.1-7.5 61.9l-13.4-13.4c3.2-15.7 4.9-31.9 4.9-48.6 0-132.5-107.5-240-240-240S16 123.5 16 256 123.5 496 256 496zM224 312c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm72 8l0 48c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8s8 3.6 8 8zm-136-8c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm16-120a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM433 325.7l52.7 52.7c20.8 20.8 20.8 54.5 0 75.3s-54.5 20.8-75.3 0L357.7 401c-9.4-9.4-9.4-24.6 0-33.9L399 325.7c9.4-9.4 24.6-9.4 33.9 0zM410.3 337L369 378.3c-3.1 3.1-3.1 8.2 0 11.3l52.7 52.7c14.5 14.6 38.1 14.6 52.7 0s14.6-38.1 0-52.7L421.7 337c-3.1-3.1-8.2-3.1-11.3 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceZipper = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;